// extracted by mini-css-extract-plugin
export default {"cronometro":"cronometro_cronometro__GiIVV","relogioWrapper":"cronometro_relogioWrapper__+lip-","titulo":"cronometro_titulo__PYqMz"};